module.exports = __webpack_public_path__ + "static/media/알림 메세지 전송.8d2dedf6.jpg";